import * as React from "react";
import { CreateOrEditExternalFeed } from "./CreateOrEditExternalFeed";
interface ExternalFeedPageProps {
    spaceId: string;
    feedId: string;
}
export function ExternalFeedPage({ spaceId, feedId }: ExternalFeedPageProps) {
    return <CreateOrEditExternalFeed spaceId={spaceId} feedId={feedId}/>;
}
